import React, { useState } from 'react'
import { Formik } from 'formik'
import * as Yup from 'yup'
import { Link, useHistory } from 'react-router-dom'
import { Paper, Typography } from '@mui/material'
import FormikControl from '../../molecules/FormikControl'
import { Card } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import logoRTG from '../../../images/logo_rtg_black.svg'
// import { useDispatch } from 'react-redux'
// import { setToken, loadUser } from '../../../store/userSlice'
import { handleOpenAlert } from '../../../lib/handleAlert'
import axios from 'axios'
import LoadingButton from '@mui/lab/LoadingButton'
// import { useHistory } from 'react-router-dom'
// import cookies from 'js-cookie'
// import { loginUser } from '../../../store/userSlice'

const useStyles = makeStyles((theme) => ({
  nested: {
    padding: theme.spacing(10),
  },
  listItem: {
    color: theme.palette.white.main,
  },
  logo: {
    filter:
      'invert(18%) sepia(44%) saturate(1598%) hue-rotate(182deg) brightness(98%) contrast(84%);',
    maxWidth: '500px',
    width: '450px',
    [theme.breakpoints.down('md')]: {
      width: 'auto',
    },
  },

  paperBack: {
    background: theme.palette.primary.light,
    position: 'absolute',
    minHeight: '450px',
    minWidth: '530px',
    margin: '0px 0px 50px 55px',
    maxWidth: '600px',
    maxHeight: '490px',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },

  paperFront: {
    position: 'relative',
    maxWidth: '540px',
    maxHeight: '450px',
    width: '100',
    height: '100%',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },

  formBg: {
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    gap: '24px',
    backgroundColor: theme.palette.primary.light,
    padding: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(2),
    },
  },
  form: {
    height: '100%',
    width: '100%',
    maxWidth: '600px',
    maxHeight: '490px',
    display: 'flex',
    gap: theme.spacing(4),
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      maxWidth: 'unset',
    },
  },
  btn: {
    background: theme.palette.primary.main,
  },
}))

const PasswordReset = () => {
  const classes = useStyles()
  const [loading, setLoading] = useState(false)
  const history = useHistory()

  return (
    <>
      <Formik
        initialValues={{ email: '' }}
        validationSchema={Yup.object({
          email: Yup.string()
            .email('Należy wpisać poprawny email')
            .required('Pole wymagane'),
        })}
        onSubmit={async (values) => {
          setLoading(true)
          axios
            .post('/api/doctor/auth/password/reset', {
              email: values.email,
            })
            .then(async (res) => {
              if (res.status == 200) {
                handleOpenAlert({
                  title: 'Sukces!',
                  subtitle:
                    'E-mail z linkiem zostanie wkrótce wysłany na podany adres',
                })
                setLoading(false)
                history.push('/login')
              }
            })
            .catch(() => setLoading(false))
        }}
      >
        {(formik) => (
          <form className={classes.formBg} onSubmit={formik.handleSubmit}>
            <Paper className={classes.paperBack} elevation={3}></Paper>
            <Card className={classes.paperFront} sx={{ minWidth: 'unset' }}>
              <div className={classes.form}>
                <Link to="/login">
                  <img className={classes.logo} src={logoRTG} alt="logo" />
                </Link>

                <div className="gap-7 flex flex-wrap flex-col">
                  <h1 className="text-left text-custom_blue_dark text-2xl">
                    Reset hasła - Krok 1
                  </h1>
                  <Typography>
                    Prosimy podać swój adres E-mail. Zostanie do Ciebie wysłany
                    link do strony, na której będzie można zmienić hasło.
                  </Typography>
                  <div className=" flex gap-4 flex-col justify-center w-9/12 mx-auto">
                    <FormikControl
                      variableName="email"
                      handleChange={formik.handleChange}
                      labelName="E-mail"
                      formik={formik}
                      type="email"
                      variant="standard"
                    />
                  </div>
                </div>
                <div className=" flex justify-end gap-8 flex-wrap sm:justify-center sm:gap-2">
                  <LoadingButton
                    className={classes.btn}
                    color="primary"
                    variant="contained"
                    loading={loading}
                    type="submit"
                    size="large"
                  >
                    Prześlij
                  </LoadingButton>
                </div>
              </div>
            </Card>
          </form>
        )}
      </Formik>
    </>
  )
}

export default PasswordReset
